module.exports = __webpack_public_path__ + "img/sv14.339bf904.svg";